module.exports = __webpack_public_path__ + "static/img/message-alert-character.44f514c.png";